import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { getFabricResource } from "store/fabric-resource/actions"
import { getFabricTradingListResource } from "store/actions"
import { downloadFabricAPI } from "helpers/fabric_resource"
import { getSeason } from "store/season/actions"
import { useHistory } from "react-router-dom"

import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import Table from "./Table"
import Skeleton from "react-loading-skeleton"
import UploadFile from "./Upload"

export default function Dough() {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useSelector(({ fabric }) => fabric)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [count, setCount] = useState(100)
  const [filter, setFilter] = useState({
    number: "",
    companyName: "",
    bunch: "",
    brand: "",
  })
  const [isShowUpload, setIsShowUpload] = useState(false)

  const onFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    dispatch(getFabricResource({ ...filter, page: 0, size: 10 }))
  }

  const onDownloadFile = () => {
    downloadFabricAPI().then(res => {
      if (res.status === 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "file.xlsx") //or any other extension
        document.body.appendChild(link)
        link.click()
      }
    })
  }

  useEffect(() => {
    if (store.status === "success") {
      setCount(store?.data?.totalPages)
    }
  }, [store?.data])

  useEffect(() => {
    let query = { ...filter }
    dispatch(getFabricResource({ ...query, ...pagination }))
  }, [dispatch, pagination])

  useEffect(() => {
    dispatch(getFabricTradingListResource())
    dispatch(getSeason("", true))
  }, [dispatch])

  return (
    <div className="page-content">
      <UploadFile
        refetch={() => dispatch(getFabricResource(filter))}
        isModal={isShowUpload}
        setIsModal={setIsShowUpload}
      />

      <Container fluid>
        <Breadcrumbs title={"生地マスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={7}>
                <Row>
                  <Col sm={3} className="pe-0">
                    <TextInputWithLabel
                      label={"生地名"}
                      placeholder={""}
                      value={filter.number}
                      type="text"
                      name="number"
                      onChange={onFilter}
                    />
                  </Col>
                  <Col sm={3} className="pe-0">
                    <TextInputWithLabel
                      label={"生地商社"}
                      placholder={""}
                      type="text"
                      name="companyName"
                      value={filter.companyName}
                      onChange={onFilter}
                    />
                  </Col>

                  <Col sm={3} className="pe-0">
                    <TextInputWithLabel
                      label={"バンチ"}
                      placeholder={""}
                      value={filter.bunch}
                      type="text"
                      name="bunch"
                      onChange={onFilter}
                    />
                  </Col>
                  <Col sm={3} className="pe-0">
                    <TextInputWithLabel
                      label={"ブランド"}
                      placeholder={""}
                      value={filter.brand}
                      type="text"
                      name="brand"
                      onChange={onFilter}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={5} className="d-flex align-items-end">
                <SButton onClick={onSearch} className="me-1 button">
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <div className="d-flex justify-content-end align-self-end mb-3">
                <SButton onClick={onDownloadFile} className="me-1 button">
                  Excelダウンロード
                </SButton>
                <SButton
                  onClick={() => setIsShowUpload(true)}
                  className="me-1 button"
                >
                  Excelアップロード
                </SButton>
                <SButton
                  className="button"
                  onClick={() => history.push("/master/dough/create")}
                >
                  新規追加
                </SButton>
              </div>
              <Col md={12}>
                {store.status === "process" ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <Table
                      page={pagination.page}
                      size={pagination.size}
                      count={count}
                      content={store.data?.content}
                      setParams={setPagination}
                      params={pagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
